import React, { useState, useEffect } from "react";
import moment from "moment";
import _ from 'lodash';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { DateRangePicker, DateRangeDelimiter } from "@material-ui/pickers";
import {
  withStyles,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import * as Var from "styles/variables";
import {
  setDateRangePicTreeHokuden,
  getHomePictreeCheckInHokuden,
  getHomePictreePhotoShootHokuden,
  getPictreeDataCheckInTrendHokuden,
  getPictreeDataPhotoShootTrendHokuden,
  getPictreeDataPhotoDenchuKaisuTrend,
  getInGameItemSalesByOccurrence,
  getPhotoShootMapDataHokuden,
  getPictreePhotoShootByAssetNtt,
  getPictreePhotoShootTrendByAssetNtt,
  getHomePictreeReportStats,
  getPictreeDataReportTrend,
  getPictreePhotoShootByAssetHokuden,
  getPictreePhotoShootTrendByAssetHokuden,
  getByAreaData,
  getBudgetSummaryData,
  getBudgetRemainTrendData,
  getBudgetBoostData,
  getBudgetBoostSourceData,
  getPictreeGroupSummaryHokuden,
} from "actions";
import PeriodHokuden from "components/PicTree/Filter/PeriodHokuden";

const useStyles = makeStyles((theme) =>
  createStyles({
    calendarWrapper: {
      paddingLeft: 8,
      flexGrow: 1,
    },
    root: {
      backgroundColor: "#fafafa",
      zIndex: 1000,
      paddingTop: 16,
      paddingLeft: 8,
      marginTop: -12,
    },
    container: {
      display: "flex",
      width: 300,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      alignItems: "baseline",
    },
    delimiter: {
      paddingTop: theme.spacing(1),
    },
    dataBtn: {
      marginTop: theme.spacing(1.2),
      marginLeft: theme.spacing(1),
      height: theme.spacing(4),
      color: Var.btnLabelColor,
    },
    grow: {
      flexGrow: 1,
    },
    sectionCalendar: {
      display: "flex",
      marginRight: theme.spacing(1),
    },
    picTreePredefined: {
      marginRight: theme.spacing(2),
    }
  })
);

const CalendarRangePicTreeHokuden = ({
  page,
  singlePeriod,
  dateRangePicTreeHokuden,
  dateRangePicTreeMinMax,
  currentPage,
  getHomePictreeCheckInHokuden,
  getHomePictreePhotoShootHokuden,
  getPictreeDataCheckInTrendHokuden,
  getPictreeDataPhotoShootTrendHokuden,
  pictreeChartSize,
  getPhotoShootMapDataHokuden,
  pictreeMapType,
  setDateRangePicTreeHokuden,
  getPictreePhotoShootByAssetNtt,
  getPictreePhotoShootTrendByAssetNtt,
  getHomePictreeReportStats,
  getPictreeDataReportTrend,
  getPictreePhotoShootByAssetHokuden,
  getPictreePhotoShootTrendByAssetHokuden,
  getByAreaData,
  getBudgetSummaryData,
  getBudgetRemainTrendData,
  getBudgetBoostData,
  getBudgetBoostSourceData,
  getPictreeGroupSummaryHokuden,
  selectedSeason,
}) => {
  const classes = useStyles();
  const [dateRangeValue, setDateRangeValue] = useState([null, null]);
  const [error, setError] = useState([null, null]);
  const [minDate, setMinDate] = useState(moment("2024-12-07").tz("Asia/Tokyo").format("YYYY/MM/DD"));
  const [maxDate, setMaxDate] = useState(moment("2025-01-12").tz("Asia/Tokyo").format("YYYY/MM/DD"));
  const isGroupPage = currentPage === "/game/pictree/hokuden/photos/group";

  const today = moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
  const todayFormatted = moment(today).format("YYYY-MM-DD");

  useEffect(() => {
    const currentJstDate = moment().tz("Asia/Tokyo").format("YYYY/MM/DD");
    handleHomeCalendar(currentJstDate);
  }, []);

  useEffect(() => {
    if (dateRangePicTreeMinMax.length > 0) {
      const defaultMaxDateFormatted = moment(dateRangePicTreeMinMax[1]).format('YYYY-MM-DD');
      const isEndDateAfterToday = moment(today).isBefore(defaultMaxDateFormatted);
      setMinDate(dateRangePicTreeMinMax[0]);
      setMaxDate(isEndDateAfterToday ? todayFormatted : dateRangePicTreeMinMax[1]);
    }
  }, [dateRangePicTreeMinMax]);

  useEffect(() => {
    const defaultMaxDateFormatted = moment(dateRangePicTreeMinMax[1]).format('YYYY-MM-DD');
    const isEndDateAfterToday = moment(today).isBefore(defaultMaxDateFormatted);
    const dateRangeValue = isEndDateAfterToday ? [dateRangePicTreeHokuden[0], todayFormatted] : dateRangePicTreeHokuden;
    setDateRangeValue(dateRangeValue);
  }, [dateRangePicTreeHokuden]);

  const handleHomeCalendar = (currentJstDate) => {
    setDateRangeValue(dateRangePicTreeHokuden);
  };

  const setRange = (newValue) => {
    const startDate = moment(newValue[0]).format("YYYY-MM-DD");
    const endDate = moment(newValue[1]).format("YYYY-MM-DD");
    setDateRangePicTreeHokuden([startDate, endDate]);
    setDateRangeValue([startDate, endDate]);
  };

  const fetchData = () => {
    if (currentPage === "/game/pictree/hokuden/checkin") {
      getHomePictreeCheckInHokuden();
      getPictreeDataCheckInTrendHokuden(pictreeChartSize);
    } else if (currentPage === "/game/pictree/hokuden/photos/overview") {
      getHomePictreePhotoShootHokuden();
      getPictreeDataPhotoShootTrendHokuden(pictreeChartSize);
    } else if (currentPage === "/game/pictree/hokuden/photos/map") {
      getPhotoShootMapDataHokuden({ type: "denchu", filter: pictreeMapType });
    } else if (currentPage === "/game/pictree/hokuden/report/overview") {
      getHomePictreeReportStats("hepco");
      getPictreeDataReportTrend("hepco");
    } else if (currentPage === "/game/pictree/hokuden/photos/asset-type") {
      getPictreePhotoShootByAssetHokuden();
      getPictreePhotoShootTrendByAssetHokuden("day");
    } else if (currentPage === "/game/pictree/hokuden/photos/by-area") {
      getByAreaData("hokuden");
    } else if (currentPage === "/game/pictree/hokuden/photos/group") {
      getPictreeGroupSummaryHokuden();
    } else if (currentPage === "/game/pictree/hokuden/budget") {
      getBudgetSummaryData({ companyCode: "hokuden" });
      getBudgetRemainTrendData({ companyCode: "hokuden" });
      getBudgetBoostSourceData({ companyCode: "hokuden" });
      getBudgetBoostData({ companyCode: "hokuden" });
    }
  };

  return (
    <div className={classes.calendarWrapper}>
      <div className={classes.root}>
        <div className={classes.sectionCalendar}>
          <div className={classes.picTreePredefined}>
            <PeriodHokuden
              singlePeriod
              currentPage={currentPage}
            />
          </div>
          {!isGroupPage && (
            <DateRangePicker
              startText="Start"
              endText="End"
              disableHighlightToday={true}
              showToolbar={false}
              allowSameDateSelection={true}
              minDate={minDate}
              maxDate={maxDate}
              value={dateRangeValue}
              onChange={(newValue) => setRange(newValue)}
              onError={([startReason, endReason], [start, end]) => {
                if (startReason === "invalidRange") {
                  setError([null, null]);
                  return;
                }
                setError([startReason, endReason]);
              }}
              renderInput={(startProps, endProps) => (
                <div className={classes.container}>
                  <TextField
                    id="standard-basic"
                    {...startProps}
                    error={Boolean(error[0])}
                    size="small"
                    disabled={page === "pictree-map" ? true : false}
                    helperText=""
                  />
                  <DateRangeDelimiter>
                    <span className={classes.delimiter}>~</span>
                  </DateRangeDelimiter>
                  <TextField
                    id="standard-basic"
                    {...endProps}
                    error={Boolean(error[0])}
                    size="small"
                    disabled={page === "pictree-map" ? true : false}
                    helperText=""
                  />
                </div>
              )}
            />
          )}
          <Button
            className={classes.dataBtn}
            variant="contained"
            color="primary"
            onClick={() => fetchData()}
          >
            GO
          </Button>
        </div>
      </div>
    </div>
  );
};

CalendarRangePicTreeHokuden.prototypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  btnStateDataFetch: state.page.btnStateDataFetch,
  dateRangePicTreeHokuden: state.page.dateRangePicTreeHokuden,
  dateRangePicTreeMinMax: state.page.dateRangePicTreeMinMax,
  currentPage: state.page.currentPage,
  pictreeView: state.pictree.pictreeView,
  pictreeChartSize: state.pictree.chartSize,
  pictreeMapType: state.pictree.mapType,
  selectedSeason: state.pictreeHokuden.selectedSeason,
});

const mapDispatchToProps = (dispatch) => ({
  setDateRangePicTreeHokuden: (param) => dispatch(setDateRangePicTreeHokuden(param)),
  getHomePictreeCheckInHokuden: (param) => dispatch(getHomePictreeCheckInHokuden(param)),
  getHomePictreePhotoShootHokuden: (param) => dispatch(getHomePictreePhotoShootHokuden(param)),
  getPictreeDataCheckInTrendHokuden: (param) => dispatch(getPictreeDataCheckInTrendHokuden(param)),
  getPictreeDataPhotoShootTrendHokuden: (param) => dispatch(getPictreeDataPhotoShootTrendHokuden(param)),
  getPictreeDataPhotoDenchuKaisuTrend: (param) => dispatch(getPictreeDataPhotoDenchuKaisuTrend(param)),
  getInGameItemSalesByOccurrence: (param) => dispatch(getInGameItemSalesByOccurrence(param)),
  getPhotoShootMapDataHokuden: (param) => dispatch(getPhotoShootMapDataHokuden(param)),
  getPictreePhotoShootByAssetNtt: (param) => dispatch(getPictreePhotoShootByAssetNtt(param)),
  getPictreePhotoShootTrendByAssetNtt: (param) => dispatch(getPictreePhotoShootTrendByAssetNtt(param)),
  getHomePictreeReportStats: (param) => dispatch(getHomePictreeReportStats(param)),
  getPictreeDataReportTrend: (param) => dispatch(getPictreeDataReportTrend(param)),
  getPictreePhotoShootByAssetHokuden: () => dispatch(getPictreePhotoShootByAssetHokuden()),
  getPictreePhotoShootTrendByAssetHokuden: (param) => dispatch(getPictreePhotoShootTrendByAssetHokuden(param)),
  getByAreaData: (param) => dispatch(getByAreaData(param)),
  getBudgetSummaryData: (param) => dispatch(getBudgetSummaryData(param)),
  getBudgetRemainTrendData: (param) => dispatch(getBudgetRemainTrendData(param)),
  getBudgetBoostData: (param) => dispatch(getBudgetBoostData(param)),
  getBudgetBoostSourceData: (param) => dispatch(getBudgetBoostSourceData(param)),
  getPictreeGroupSummaryHokuden: () => dispatch(getPictreeGroupSummaryHokuden()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(CalendarRangePicTreeHokuden));
